import tenantConstants from '@constants';

// `wallet_type` on user, agency and listing responses identifies the client's wallet:
// - "currency": one shared credits balance spent on any product (default outside Zameen)
// - "credit":   per-product credits (10 Hot, 5 Refresh, ...), what the Profolio "products" screens call quota
// - "quota":    the legacy Zameen quota system
// credit_user / is_credit_user stay only for older responses.
export const WALLET_TYPES = { CURRENCY: 'currency', CREDIT: 'credit' };

// wallet_type is read only where product quota is on; other tenants, "quota" and responses without it keep the old flag.
export const isCurrencyWallet = (data) => {
  if (!tenantConstants.QUOTA_ENABLED) return data?.credit_user ?? data?.is_credit_user;
  if (data?.wallet_type === WALLET_TYPES.CURRENCY) return true;
  if (data?.wallet_type === WALLET_TYPES.CREDIT) return false;
  return data?.credit_user ?? data?.is_credit_user;
};
